import React from 'react';
import { PageHeaderLayout } from '@/ui/layout';
import PageHeaderActions from './PageHeaderActions';

type Props = {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
};

export default function PageHeader({ title, subtitle, children }: Props) {
  return (
    <PageHeaderLayout>
      <div className="page-header__titles">
        <h1>{title}</h1>
        {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
      </div>
      {children ? <PageHeaderActions>{children}</PageHeaderActions> : null}
    </PageHeaderLayout>
  );
}
